import { getTestsService } from '@/api/services/testService'
import { TestPreview } from '@/api/services/types/testTypes'
import { Card, CardContent, CardHeader } from '@/components/card'
import PageWrap from '@/components/layout/containers/PageWrap'
import { Skeleton } from '@/components/skeleton'
import { Seo } from '@/components/specific/seo/Seo'
import { Button } from '@/components/ui/common/Button'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import DashboardLayout from '../dashboard/DashboardLayout'
import { TestCard } from './components/TestCard'
import { getImageUrl } from '@/utils/getImageUrl'

function Home() {
  const [page, setPage] = useState(1)
  const pageSize = 12
  const navigate = useNavigate()

  const { data, isLoading, error } = useQuery({
    queryKey: ['tests', page],
    queryFn: async () => {
      const response = await getTestsService({ page, pageSize, sort: 1, filter: '' })
      if (!response.success) {
        console.error('Błąd API:', response.data)
        return null
      }
      return response.data
    }
  })

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
  }

  const handleTestClick = (testId: string) => {
    navigate(`/tests/${testId}/session`)
  }

  return (
    <>
      <Seo />
      <PageWrap>
        <DashboardLayout>
          <div className="min-h-screen w-full bg-[#f8f9fa]">
            <div className="p-6">

              {isLoading ? (
                <div className="space-y-4 w-full">
                  {[...Array(3)].map((_, i: number) => (
                    <Card key={i} className='w-full'>
                      <CardHeader>
                        <Skeleton className="h-6 w-3/4" />
                      </CardHeader>
                      <CardContent>
                        <Skeleton className="mb-2 h-4 w-1/2" />
                        <Skeleton className="h-4 w-1/3" />
                      </CardContent>
                    </Card>
                  ))}
                </div>
              ) : error ? (
                <div className="text-red-500">Wystąpił błąd podczas ładowania testów</div>
              ) : (
                <>
                  <div className="space-y-8 w-full">
                      <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">
                        {data?.items.map((test: TestPreview) => (
                          <TestCard
                          id={test.id}
                          image={getImageUrl(test.imageFileId)}
                          title={test.title}
                          goal={test.purpose}
                          limitations={test.constraints}
                          procedure={test.procedure}
                          recommendations={test.recommendations}
                          onStartTest={() => handleTestClick(test.id)}
                          />
                        
                        ))}
                      </div>
                  </div>

                  { Math.ceil((data?.total || 0) / pageSize) !== 1 &&
                    <div className="mt-6 flex justify-center gap-2">
                    <Button
                      disabled={page === 1}
                      onClick={() => handlePageChange(page - 1)}
                      variant="outline"
                    >
                      Poprzednia
                    </Button>
                    <span className="flex items-center px-4">
                      Strona {page} z {Math.ceil((data?.total || 0) / pageSize)}
                    </span>
                    <Button
                      disabled={page >= Math.ceil((data?.total || 0) / pageSize)}
                      onClick={() => handlePageChange(page + 1)}
                      variant="outline"
                    >
                      Następna
                    </Button>
                  </div>
                  }
                </>
              )}
            </div>
          </div>
        </DashboardLayout>
      </PageWrap>
    </>
  )
}

export default Home
